import { GooglePurchase, GoogleSubscription } from "../GoogleSubscription";

export class MockGoogleSubscription implements GoogleSubscription {
  public purchaseData: string;
  public dataSignature: string;

  constructor(purchase: GooglePurchase) {
    this.purchaseData = JSON.stringify(purchase);
    this.dataSignature = "__mock__";
  }
}
